import { Editor } from './editor';
import { Cursor, CursorType, Rect } from '../common/interfaces';
import { isWindows } from '../common/userAgentUtils';
import { hasPressure } from './tablet';

export function createCursor(): Cursor {
  return {
    x: -1000,
    y: -1000,
    size: 0,
    type: CursorType.None,
    show: true,
    lastX: 0,
    lastY: 0,
    lastType: CursorType.None,
    lastSize: 0,
    lastVisible: true,
    lastShow: true,
  };
}

export function resetCursor(cursor: Cursor) {
  cursor.type = CursorType.None;
  cursor.size = 0;
}

export function moveCursor(cursor: Cursor, x: number, y: number) {
  cursor.x = x;
  cursor.y = y;
}

export function useSyntheticCursor(editor: Editor) {
  return isWindows && editor.tabletConfig.api === 'pen' && hasPressure;
}

export function updateCursor(cursor: Cursor, editor: Editor, dirtyRect: Rect) {
  let visible = false;
  let changed = false;
  let minX = Math.min(cursor.x, cursor.lastX);
  let maxX = Math.max(cursor.x, cursor.lastX);
  let minY = Math.min(cursor.y, cursor.lastY);
  let maxY = Math.max(cursor.y, cursor.lastY);
  let maxSize = cursor.size;
  const tool = editor.activeTool;

  if (tool?.canvasCursor && !editor.movingView && !(tool.syntheticCursor && !useSyntheticCursor(editor))) {
    const newCursorSize = tool.size ? (tool.size * editor.view.scale) : 12; // 12 is around the max size for synthetic cursors
    const newCursorType = tool.canvasCursor;

    if (cursor.size !== newCursorSize || cursor.lastType !== newCursorType) {
      cursor.size = newCursorSize;
      cursor.type = newCursorType;
      cursor.lastType = cursor.type;
      changed = true;
    }

    visible = true;

    if (cursor.lastX !== cursor.x || cursor.lastY !== cursor.y || cursor.lastSize !== cursor.size) {
      cursor.lastX = cursor.x;
      cursor.lastY = cursor.y;
      cursor.lastSize = cursor.size;
      changed = true;
    }
  } else {
    cursor.type = CursorType.None;
    cursor.lastType = CursorType.None;
  }

  maxSize = Math.max(maxSize, cursor.size);

  const halfMaxSize = Math.max(Math.ceil(maxSize / 2), 10) + 2;
  const left = Math.floor(minX - halfMaxSize);
  const right = Math.ceil(maxX + halfMaxSize);
  const top = Math.floor(minY - halfMaxSize);
  const bottom = Math.ceil(maxY + halfMaxSize);

  dirtyRect.x = left;
  dirtyRect.y = top;
  dirtyRect.w = right - left;
  dirtyRect.h = bottom - top;

  if (cursor.lastVisible !== visible) {
    cursor.lastVisible = visible;
    changed = true;
  }

  if (cursor.lastShow !== cursor.show) {
    cursor.lastShow = cursor.show;
    changed = true;
  }

  return changed;
}
